import {
  OWNERSHIP_MAX,
  OWNERSHIP_MIN,
} from "../../CaseDetailsDrawer/Profiles/ProfilesTreeCard/utils";

export const parseOwnershipToNumber = (value: unknown): number | null => {
  if (value == null || value === "" || value === "--") return null;
  const n =
    typeof value === "number"
      ? value
      : typeof value === "string"
        ? parseFloat(value.replace(/%/g, ""))
        : Number.NaN;
  if (Number.isNaN(n)) return null;
  return Math.min(OWNERSHIP_MAX, Math.max(OWNERSHIP_MIN, n));
};

export const formatOwnershipDisplay = (value: string | number | null | undefined): string => {
  const n = parseOwnershipToNumber(value);
  return n == null ? "--" : `${n}%`;
};

export const parseOwnershipValue = (value: unknown): string => {
  const n = parseOwnershipToNumber(value);
  return n == null ? "--" : String(n);
};
